import React from 'react';


const SavingIndicator = ({ state, guestId, field }) => {
  if (!state) return null;

  const testId = `${state === 'saving' ? 'saving' : 'success'}-indicator-${guestId}-${field}`;

  return (
    <div className={`saving-indicator ${state}`} data-testid={testId}>
      {state === 'saving' ? (
        <svg className="saving-spinner" viewBox="0 0 24 24">
          <circle className="path" cx="12" cy="12" r="10" fill="none" strokeWidth="3" />
        </svg>
      ) : (
        <svg className="success-check" viewBox="0 0 24 24">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
        </svg>
      )}
    </div>
  );
};

export default SavingIndicator;

